import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { accountNumber, password, username, userPassMap } from '../internal.js'

const credentialTypes = [username, password, 'app-id', 'api-key'] as const
const locationCredentialTypes = [accountNumber] as const

export type rdfsCredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]

export const rdfsDocumentTypes = [
  'invoice',
  'proof-of-delivery',
  'signed-bol',
  'weight-cert',
] as const satisfies readonly DocumentType[]

export const rdfs: CarrierDef<rdfsCredType> = {
  name: 'Roadrunner Transportation Services',
  scac: 'rdfs',
  ltlServices: [
    { id: 'standard', name: 'Standard' },
    { id: 'volume', name: 'Volume' },
  ],
  credentialTypes,
  locationCredentialTypes,
  legacyCredMap: [...userPassMap, ['account-number', 'ref1']],
  engineLayers: [
    'rating',
    'bol',
    'pickup',
    'tracking',
    'profinder',
    'documents',
    'cancel',
  ],
  documentTypes: rdfsDocumentTypes,
  credentialConfig: {
    'account-number': { customerIdentifier: true },
    'app-id': { nonsensitive: true },
  },
}
